module.exports = __webpack_public_path__ + "img/craftsmanship.27a9be24.png";